import { MODEL_HOYEONG_LAB_TYPE, useSectionScrollModel } from '@/components/common/context/SectionScrollModelProvider';
import { StaticImageSection } from '@/components/event/Sections';

export const ModelContent = () => {
  const { labType } = useSectionScrollModel();
  const modelImageNamePrefix = labType === MODEL_HOYEONG_LAB_TYPE ? '-hoyeong' : '';
  return (
    <>
      <StaticImageSection
        sectionId={'01'}
        imagePath={`/refund/images/home/event/model-marketing/model${modelImageNamePrefix}-main.png?lab_type=${labType}`}
        className={'bg-gray-50'}
        maxWidth={'700'}
      />
      <StaticImageSection
        sectionId={'02'}
        imagePath={'/refund/images/home/event/model-marketing/model-lookup-condition-gray.png'}
        className={'bg-[#F0F2F3]'}
        maxWidth={'700'}
      />
      <StaticImageSection
        sectionId={'03'}
        imagePath={`/refund/images/home/event/model-marketing/model${modelImageNamePrefix}-refund-process.png?lab_type=${labType}`}
        className={'bg-[#E3E6FF]'}
        maxWidth={'700'}
      />
      <StaticImageSection
        sectionId={'04'}
        imagePath={'/refund/images/home/event/model-marketing/model-company-comparison.png'}
        className={'bg-[#22262b]'}
        maxWidth={'700'}
      />
      <StaticImageSection
        sectionId={'05'}
        imagePath={`/refund/images/home/event/model-marketing/model${modelImageNamePrefix}-refund-policy.png?lab_type=${labType}`}
        className={'bg-[#EFEFED]'}
        maxWidth={'700'}
      />
      <StaticImageSection
        sectionId={'06'}
        imagePath={'/refund/images/home/event/model-marketing/model-refund-example.png'}
        className={'bg-gray-900'}
        maxWidth={'700'}
      />
    </>
  );
};
